var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmpty = function SvgEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .5a9 9 0 1 0 9 9 9 9 0 0 0-9-9",
    className: "icon-shadow",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c757d",
    d: "M9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9",
    className: "icon-background"
  })));
};
export default SvgEmpty;